import React, { useState } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { Badge, Menu, Text, TouchableRipple, useTheme } from 'react-native-paper';
import { useNavigation, useNavigationState } from '@react-navigation/native';

import { SCREEN_NAMES } from '../../routes';
import Environment from '../../../models/Environment';
import { useAuth } from '../../../contexts';
import { DatNavigationUtils } from '../DatNavigator';

export type MobileMenuProps = {
  countItemsInCart: number;
  iconColor?: string;
  onNavigateToLocationsUrl: () => void;
  onNavigateToViewResultsUrl: () => void;
};

export const MobileMenu = (props: MobileMenuProps) => {
  const theme = useTheme();
  const { session } = useAuth();
  const { countItemsInCart, iconColor, onNavigateToLocationsUrl, onNavigateToViewResultsUrl } = props;
  const navigationState = useNavigationState((state) => state);
  const navigation = useNavigation();

  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isMenuSelected = (screen: string): boolean => {
    return DatNavigationUtils.isSelected(screen, navigationState);
  };

  const navigateToScreen = (screen: string) => {
    // @ts-ignore
    navigation.navigate(screen);
    setMobileMenuOpen(false);
  };

  const navigateToLocationsUrl = () => {
    onNavigateToLocationsUrl();
    setMobileMenuOpen(false);
  };

  const navigateToViewResultsUrl = async () => {
    onNavigateToViewResultsUrl();
    setMobileMenuOpen(false);
  };

  return (
    <Menu
      visible={isMobileMenuOpen}
      onDismiss={() => setMobileMenuOpen(false)}
      anchorPosition={'bottom'}
      anchor={
        <TouchableOpacity onPress={() => setMobileMenuOpen(true)}>
          <View style={{ margin: 10 }}>
            <MaterialIcons name={'menu'} size={24} color={iconColor || theme.colors.primary} />
            <Badge
              style={[
                {
                  fontSize: 15,
                  position: 'absolute',
                  top: -5,
                  left: 10,
                },
                !isMobileMenuOpen ? {} : { display: 'none' },
              ]}
              visible={countItemsInCart > 0}
              selectionColor={theme.colors.secondary}
            >
              {countItemsInCart}
            </Badge>
          </View>
        </TouchableOpacity>
      }
    >
      <Menu.Item
        style={[
          isMenuSelected(SCREEN_NAMES.BROWSE)
            ? {
                borderLeftWidth: 2,
                borderLeftColor: theme.colors.secondary,
              }
            : {},
        ]}
        onPress={() => navigateToScreen(SCREEN_NAMES.BROWSE)}
        title="Browse Tests"
      />
      <Menu.Item
        style={[
          isMenuSelected(SCREEN_NAMES.HOW_IT_WORKS)
            ? {
                borderLeftWidth: 2,
                borderLeftColor: theme.colors.secondary,
              }
            : {},
        ]}
        onPress={() => navigateToScreen(SCREEN_NAMES.HOW_IT_WORKS)}
        title="How It Works"
      />
      <Menu.Item
        style={[
          isMenuSelected(SCREEN_NAMES.HELP)
            ? {
                borderLeftWidth: 2,
                borderLeftColor: theme.colors.secondary,
              }
            : {},
        ]}
        onPress={() => navigateToScreen(SCREEN_NAMES.HELP)}
        title="Help / FAQ"
      />
      <Menu.Item
        style={[
          isMenuSelected(SCREEN_NAMES.HELP)
            ? {
                borderLeftWidth: 2,
                borderLeftColor: theme.colors.secondary,
              }
            : {},
        ]}
        onPress={() => navigateToScreen(SCREEN_NAMES.CONTACT_US)}
        title="Contact Us"
      />
      {!session?.appConfig.serviceAreasEnabled && (
        <Menu.Item
          style={[
            isMenuSelected(SCREEN_NAMES.LAB_LOCATIONS)
              ? {
                  borderLeftWidth: 2,
                  borderLeftColor: theme.colors.secondary,
                }
              : {},
          ]}
          onPress={() => navigateToLocationsUrl()}
          title="Lab Locations"
        />
      )}
      {session?.appConfig.serviceAreasEnabled && (
        <Menu.Item
          style={[
            isMenuSelected(SCREEN_NAMES.SERVICE_AREAS)
              ? {
                  borderLeftWidth: 2,
                  borderLeftColor: theme.colors.secondary,
                }
              : {},
          ]}
          onPress={() => navigateToScreen(SCREEN_NAMES.SERVICE_AREAS)}
          title="Service Areas"
        />
      )}

      <Menu.Item
        style={[
          isMenuSelected(SCREEN_NAMES.RESULTS)
            ? {
              borderLeftWidth: 2,
              borderLeftColor: theme.colors.secondary,
            }
            : {},
        ]}
        onPress={() => navigateToViewResultsUrl()}
        title="View Results"
      />

      <TouchableRipple onPress={() => navigateToScreen(SCREEN_NAMES.CART)}>
        <View
          style={[
            { flexDirection: 'row', alignItems: 'center' },
            isMenuSelected(SCREEN_NAMES.CART)
              ? {
                  borderLeftWidth: 2,
                  borderLeftColor: theme.colors.secondary,
                }
              : {},
          ]}
        >
          <Text style={{ padding: 20, fontSize: 16, fontWeight: 400 }}>Cart</Text>
          <MaterialIcons name={'shopping-cart'} size={20} color={theme.colors.primary} />
          <Badge style={{ fontSize: 15, position: 'absolute', top: 5, left: 80 }} visible={countItemsInCart > 0} selectionColor={theme.colors.secondary}>
            {countItemsInCart}
          </Badge>
        </View>
      </TouchableRipple>
      {!session?.appConfig.guestCheckoutEnabled && (
        <Menu.Item
          style={[
            isMenuSelected(SCREEN_NAMES.AUTH)
              ? {
                  borderLeftWidth: 2,
                  borderLeftColor: theme.colors.secondary,
                }
              : {},
          ]}
          onPress={() => navigateToScreen(SCREEN_NAMES.AUTH)}
          title="Sign In"
        />
      )}
      {Environment.isDevelopmentMode && <Menu.Item onPress={() => navigateToScreen(SCREEN_NAMES.DEBUG)} title="Dev Tools" />}
    </Menu>
  );
};
